var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecivedTickChatSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5011 5.25086L12.4436 4.19336L7.68859 8.94836L8.74609 10.0059L13.5011 5.25086ZM16.6811 4.19336L8.74609 12.1284L5.61109 9.00086L4.55359 10.0584L8.74609 14.2509L17.7461 5.25086L16.6811 4.19336ZM0.308594 10.0584L4.50109 14.2509L5.55859 13.1934L1.37359 9.00086L0.308594 10.0584Z",
    fill: "url(#paint0_linear_2993_1943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2993_1943",
    x1: 0.308594,
    y1: 14.2509,
    x2: 9.01429,
    y2: -0.842917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecivedTickChatSvg);
export default __webpack_public_path__ + "static/media/recivedTickChatSVG.a7fded407809bc964a7c89d3fdee548d.svg";
export { ForwardRef as ReactComponent };